if (!customElements.get('a-with-in-stock-filter')) {
    customElements.define('a-with-in-stock-filter', 
        class AWithInStockFilter extends HTMLElement {
            constructor() {
                super();
                this.onClick = this.onClick.bind(this);
            }

            connectedCallback() {
                this.addEventListener('click', this.onClick);
            }

            disconnectedCallback() {
                this.removeEventListener('click', this.onClick);
            }

            onClick(event) {
                event.preventDefault();
                const link = this.getAttribute('href');
                if (!link) return;

                let linkWithFilterInStock = new URL(link, window.location.origin);
                // find filter.p.m.custom.available_regions in link
                const availableRegionsFilter = window.location.search.includes('filter.p.m.custom.available_regions');
                if (availableRegionsFilter) {
                    const regionMatch = window.location.search.match(/filter\.p\.m\.custom\.available_regions=([^&]+)/);
                    if (regionMatch && regionMatch[1]) {
                        const regionValue = decodeURIComponent(regionMatch[1]);
                        linkWithFilterInStock.searchParams.set('filter.p.m.custom.available_regions', regionValue);
                    }
                } else {
                    linkWithFilterInStock.searchParams.delete('filter.p.m.custom.available_regions');
                }

                window.location.href = linkWithFilterInStock.href;
            }
        }
    );
}